var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_c('AccountLink',{attrs:{"account":_vm.issuer}}),_vm._v("\n    ("+_vm._s(_vm._f("delim")(_vm._f("round")(_vm.value)))+" "),_c('sup',[_vm._v(_vm._s(_vm.currency))]),_vm._v(")\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }